module.exports = __webpack_public_path__ + "img/38217e0935ec50577ace08653d5d7dba.svg";